import React, {useState} from 'react'

export default function TextForms(props) {
    const handleUpClick = ()=>{
        // console.log("convert button is clicked" + text);
        let newText = text.toUpperCase();
        setText(newText)
    }

    const handleLoClick = () =>{
        let newText = text.toLocaleLowerCase();
        setText(newText)
    }

    const handleOnChange = (event)=>{
        // console.log("You have clicked on handle on change")
        setText(event.target.value)
    }

    const handleClearClick = () =>{
        let newText = " ";
        setText(newText)
    }
    const handleCopy = ()=>{
        var text = document.getElementById("myBox");
        text.select()
        navigator.clipboard.writeText(text.value)
    }
    const [text, setText] = useState('Enter your text here');
    return (
        <>
        <div>
            <h2>{props.heading}</h2>
            <div className="mb-3">
                
                <textarea className="form-control" id="myBox" value={text} onChange={handleOnChange} rows="7"></textarea>
                <button className="btn btn-primary my-3 mx-1" onClick={handleUpClick}>Convert to Uppercase</button>
                <button className="btn btn-primary my-3 mx-1" onClick={handleLoClick}>Convert to Lowercase</button>
                <button className="btn btn-primary my-3 mx-1" onClick={handleClearClick}>Clear Text</button>
                <button className="btn btn-primary my-3 mx-1" onClick={handleCopy}> Copy Text</button>
            </div>
        </div>

        <div className="container my-3">
            <h2>Summary of your text</h2>
            <p><b>{text.split(" ").length} words, {text.length} characters</b></p>
            <p>{0.008*text.split(" ").length} Minutes to read </p>

            {/* <h2>Preview</h2>
            <p>{text}</p> */}
        </div>

        </>
    )
}
